import { CommonFragments } from './common.fragments';

export class HoldingsFragments {
  /*
   * GraphQL Fragment for the Top Ten Holdings Exhibit
   */
  public static topTenHoldingsFragment = `
        topTenHoldingsExhibit {
            availableDates
            effectiveDate
            holdings {
                name
                sectorName
                industryName
                marketValue
                percentageTotalNetAssets
                percentageChange
            }
            ${CommonFragments.disclaimerFragment}
        }
    `;

  public static fullHoldingsFragment = `
        fullHoldingsExhibit {
            availableDates
            effectiveDate
            holdings {
                name
                sectorName
                industryName
                tickerSymbol
                marketValue
                percentageTotalNetAssets
                percentageChange
                holdingCouponRate
                holdingMaturityDate
            }
            ${CommonFragments.disclaimerFragment}
        }
    `;

  public static readonly holdingsFragment = `
    metadata {
        assetTypeName
    }
    ${HoldingsFragments.topTenHoldingsFragment}
    ${HoldingsFragments.fullHoldingsFragment}
    `;
}
